import { useMutation, useQuery } from 'react-query';
import companiesAdminApi, { AdminCompanyListParams, UpdateCompanyStatus } from 'services/companiesAdmin';

export const GET_ADMIN_COMPANIES = 'getAdminCompanies';

export const useGetAdminCompanies = (params: AdminCompanyListParams) =>
  useQuery([GET_ADMIN_COMPANIES, params], () => companiesAdminApi.getCompaniesAdmin(params), {
    keepPreviousData: true,
  });

export const useUpdateCompanyAdminStatus = () =>
  useMutation((body: UpdateCompanyStatus) => companiesAdminApi.updateStatus(body), {
    mutationKey: 'updateCompanyAdminStatus',
  });
